import { Dialog, DialogContent, Stack, Button, DialogActions } from "@mui/material";
import * as React from "react";
import { useTheme } from "@emotion/react";
import masrafLimitPng from "../../assets/images/SeyahatMasrafLimitTablosu2025.jpg";
export default function UserLimitedDialog({ open, onClose }) {
  let theme = useTheme();
  return (
    <>
      {masrafLimitPng && (
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="form-dialog-title"
          maxWidth="lg"
          fullWidth={true}
        >
          <DialogContent>
            <img alt="masrafLimitPng" src={masrafLimitPng} width="100%" className="center" />
          </DialogContent>
          <DialogActions sx={{ pr: 2.5, justifyContent: "space-between" }}>
            <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
              <Button
                sx={{ color: theme.palette.error.dark }}
                className="btnMedlog"
                onClick={onClose}
                color="error"
              >
                Kapat
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
